import React from 'react';
const TermsConditions = () => {
  return <div className="w-full" data-id="element-630">
      {/* Header Section */}
      <section className="relative py-20 bg-[#1A5F7A]" data-id="element-631">
        <div className="container mx-auto px-4" data-id="element-632">
          <div className="text-center" data-id="element-633">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-634">
              Terms & Conditions
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-635">
              The terms governing our service agreement
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-636">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-637">
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-638">
            <h2 className="text-2xl font-bold text-[#1A5F7A] mb-6" data-id="element-639">
              Terms and Conditions of Service – Realmpoint
            </h2>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-640">
              1. Introduction and Acceptance of Terms
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-641">
              This website (realmpoint.it.com) is owned and operated by
              Realmpoint. Throughout this site, and in these Terms and
              Conditions, the terms "we," "us," and "our" refer to Realmpoint.
              Realmpoint provides this website, including all content, tools,
              and services available from this site, to you, the user,
              conditioned upon your acceptance of all terms, conditions,
              policies, and notices stated herein. These Terms and Conditions of
              Service ("Terms") govern your access to and use of the Realmpoint
              website and your purchase and use of any service plans offered by
              us. By accessing or using any part of the site, or by purchasing a
              service plan, you agree to be bound by these Terms. If you do not
              agree to all the terms and conditions of this Agreement, then you
              may not access the website or use any services. These Terms
              constitute a legally binding agreement between you and Realmpoint.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-642">
              2. Company Information
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-643">
              Business Name: Realmpoint
              <br data-id="element-644" />
              Website Address: realmpoint.it.com
              <br data-id="element-645" />
              Business Address: 19 Clayton St, Newcastle upon Tyne NE1 5PY
              <br data-id="element-646" />
              Customer Service Email: bijayathakur8098@gmail.com
              <br data-id="element-647" />
              Phone Number: 0800 055 4969
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-648">
              3. Service Plans Overview
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-649">
              Realmpoint specialises in providing fast, reliable appliance
              repair and maintenance cover plans across the UK. Our service
              plans are designed to give you peace of mind by covering the
              repair and maintenance of specific household appliances and
              systems that you select. Each service plan entitles customers to
              unlimited repairs on covered appliances during the active
              subscription period, subject to the terms, conditions, and
              exclusions outlined herein. Full details of each available plan,
              including specific pricing, duration of cover, what is included
              and excluded, eligibility criteria, and any specific terms
              applicable to particular appliances, are clearly available on our
              product pages and during the checkout process on our website. We
              encourage you to review these details carefully before making a
              purchase.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-650">
              4. Pricing, Payments & Order Confirmation
            </h3>
            <h4 className="font-bold text-[#1A5F7A] mb-2" data-id="element-651">
              4.1. Pricing and Currency:
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-652">
              All prices displayed on our website and quoted for our service
              plans are in GBP (£ - British Pounds Sterling), and all charges
              will be processed exclusively in GBP.
            </p>
            <h4 className="font-bold text-[#1A5F7A] mb-2" data-id="element-653">
              4.2. Payment Methods:
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-654">
              We accept secure payments via major debit and credit cards (e.g.,
              Visa, Mastercard) and Direct Debit, where applicable. By providing
              your payment details, you confirm that you are authorised to use
              the chosen payment method and that the information provided is
              accurate. Payments are processed via secure, third-party payment
              gateways.
            </p>
            <h4 className="font-bold text-[#1A5F7A] mb-2" data-id="element-655">
              4.3. Order Confirmation:
            </h4>
            <p className="text-gray-600 mb-8" data-id="element-656">
              Upon successful completion of your purchase and payment, you will
              receive an order confirmation email to the address you provided.
              This email will serve as your proof of purchase and confirmation
              of your service plan activation. If you do not receive this
              confirmation within one hour of your purchase, please contact
              bijayathakur8098@gmail.com.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-657">
              5. Commencement and Duration of Your Plan
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-658">
              Your service plan Agreement commences on the date your
              subscription payment is successfully processed and confirmed
              ("Commencement Date"). The plan will remain in force for the fixed
              duration specified at the time of your purchase (e.g., "a period
              of twelve (12) months," "a period of two (2) years," etc.), unless
              terminated earlier in accordance with the provisions of this
              Agreement. Your service will automatically expire at the end of
              the agreed duration, unless you choose to renew it.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-659">
              6. Your Right to Cancel & Refunds
            </h3>
            <h4 className="font-bold text-[#1A5F7A] mb-2" data-id="element-660">
              6.1. Cooling-Off Period:
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-661">
              You have a statutory right to cancel your service plan and receive
              a full refund within 14 calendar days from the Commencement Date
              of your plan. This is known as the "Cooling-Off Period." To
              exercise this right, you must clearly inform us of your decision
              to cancel by contacting us via email at bijayathakur8098@gmail.com
              or by phone at 0800 055 4969.
            </p>
            <h4 className="font-bold text-[#1A5F7A] mb-2" data-id="element-662">
              6.2. Cancellations After Cooling-Off Period:
            </h4>
            <p className="text-gray-600 mb-2" data-id="element-663">
              Partial Refunds (Up to 28 days): Cancellation requests made after
              the 14-day Cooling-Off Period but within 28 calendar days from the
              Commencement Date may be considered at our discretion. Any refunds
              granted during this period will be assessed on a pro-rata basis,
              taking into account the duration of coverage already provided and
              any services rendered.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-664">
              No Refunds (After 28 days): After 28 calendar days from the
              Commencement Date, refunds will generally no longer be available,
              regardless of whether services have been utilised, as the service
              plan coverage will have been active for that period.
            </p>
            <h4 className="font-bold text-[#1A5F7A] mb-2" data-id="element-665">
              6.3. Refund Processing:
            </h4>
            <p className="text-gray-600 mb-8" data-id="element-666">
              Any approved refunds will be processed and returned to your
              original payment method. Please allow 5–10 working days for the
              refund to appear in your account, as processing times may vary
              depending on your bank or payment provider.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-667">
              7. Exclusions from Service Plans & Prohibited Use
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-668">
              To maintain fair use and service quality, and to clarify the scope
              of our cover, the following are generally excluded from all
              service plans and are considered prohibited use of our
              services/website:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-669">
              <li className="mb-2" data-id="element-670">
                Pre-existing Faults: Any faults or damage to appliances that
                existed prior to the Commencement Date of your service plan.
              </li>
              <li className="mb-2" data-id="element-671">
                Damage from Misuse/Neglect: Faults or damage caused by misuse,
                deliberate damage, neglect, accidents (e.g., drops, spills),
                unauthorised repair attempts, improper installation, or
                tampering with the appliance by you or any third party not
                authorised by Realmpoint.
              </li>
              <li className="mb-2" data-id="element-672">
                Non-Functional Repairs: Repairs or services unrelated to the
                normal operational function of the appliance, such as purely
                cosmetic damage (e.g., scratches, dents, discolouration).
              </li>
              <li className="mb-2" data-id="element-673">
                Non-Manufacturer Use: Appliances not used according to the
                manufacturer's guidelines, instructions, or specifications.
              </li>
              <li className="mb-2" data-id="element-674">
                Unauthorised Modifications: Damage resulting from any
                modifications or alterations to the appliance not approved by
                the manufacturer.
              </li>
              <li className="mb-2" data-id="element-675">
                Consumables: Replacement of consumable items such as batteries,
                bulbs, fuses, filters, or cleaning unless their failure is a
                direct result of a covered breakdown.
              </li>
              <li className="mb-2" data-id="element-676">
                External Factors: Damage caused by external events beyond the
                appliance itself, such as power surges, abnormal voltage, fire,
                flood, lightning, pest infestation, or issues with your home's
                electrical, water, or drainage systems external to the
                appliance.
              </li>
              <li className="mb-2" data-id="element-677">
                Commercial Use: Appliances used for non-domestic or commercial
                purposes, unless such usage is expressly stated and agreed upon
                in writing by Realmpoint at the time of subscription.
              </li>
              <li className="mb-2" data-id="element-678">
                Illegal/Fraudulent Use: Any illegal or fraudulent use of our
                services or website, including attempts to gain unauthorised
                access to our systems or data.
              </li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-679">
              If any of these exclusions apply, or if there is evidence of
              prohibited use, your service plan may be cancelled by us without
              refund or further support.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-680">
              8. Contact Us
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-681">
              For any queries, service requests, cancellation notices, or
              communication relating to this Agreement, please contact us using
              the details below. We will reply during business hours.
            </p>
            <p className="text-gray-600" data-id="element-682">
              Realmpoint
              <br data-id="element-683" />
              Customer Service Email: bijayathakur8098@gmail.com
              <br data-id="element-684" />
              Phone Number: 0800 055 4969
              <br data-id="element-685" />
              Business Address: 19 Clayton St, Newcastle upon Tyne NE1 5PY
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default TermsConditions;